export default __webpack_public_path__ + "static/media/link_users.36093875.svg";